// extracted by mini-css-extract-plugin
export default {"addMemo":"Memos_addMemo__VkmM0","customFileUpload":"Memos_customFileUpload__jFlNE"};